import { PackagedBeerDetailsContainer } from "../../../../gql/hooks";

const getContainerType = (
  assortments?:
    | null
    | {
        productId: number;
        container?: PackagedBeerDetailsContainer | null | undefined;
      }[],
  type?: PackagedBeerDetailsContainer,
) => {
  const data = assortments?.filter((_) =>
    !type ? !_.container : _.container === type,
  );

  return (
    data
      ?.filter(
        (_, index) =>
          data.findIndex((_x) => _x.productId === _.productId) === index,
      )
      ?.map((_) => _.productId) || []
  );
};

export default getContainerType;
